/**
 * AUTO-GENERATED — do not edit manually.
 * Run `pnpm sync:tokens --overwrite` to regenerate from Figma.
 */

import { primitives } from '../../primitives'
import type { SemanticTokens } from './types'

export const lightTokens = {
  text: {
    default: primitives.neutrals.alvieBlack['100'],
    onColour: primitives.neutrals.white['100']
  },
  icons: {
    default: primitives.neutrals.alvieBlack['100']
  },
  gradient: {
    fade: {
      solid: primitives.neutrals.white['100'],
      middle: primitives.neutrals.white['75%'],
      clear: primitives.neutrals.white['0%']
    }
  },
  background: {
    main: {
      default: primitives.neutrals.white['100'],
      hover: primitives.neutrals.stone['100'],
      pressed: primitives.neutrals.stone['90'],
      dragged: primitives.neutrals.stone['100'],
      selected: primitives.neutrals.stone['110'],
      focused: primitives.neutrals.white['100'],
      disabled: primitives.neutrals.stone['90'],
      inverse: {
        default: primitives.neutrals.alvieBlack['100']
      },
      tonalMedium: primitives.neutrals.stone['100'],
      tonalSoft: primitives.neutrals.stone['90'],
      accent: primitives.main.alvieBlue['100']
    },
    tonal: {
      superSoft: {
        default: primitives.neutrals.stone['90'],
        hover: primitives.neutrals.stone['110'],
        pressed: primitives.neutrals.stone['100'],
        dragged: primitives.neutrals.stone['110'],
        selected: primitives.neutrals.stone['120'],
        disabled: primitives.neutrals.stone['90'],
        focused: primitives.neutrals.stone['90'],
        inverse: {
          default: primitives.neutrals.stone['180']
        }
      },
      soft: {
        default: primitives.neutrals.stone['100'],
        hover: primitives.neutrals.stone['120'],
        pressed: primitives.neutrals.stone['110'],
        dragged: primitives.neutrals.stone['120'],
        selected: primitives.neutrals.stone['155'],
        disabled: primitives.neutrals.stone['90'],
        focused: primitives.neutrals.stone['100'],
        inverse: {
          default: primitives.neutrals.stone['160']
        }
      },
      medium: {
        default: primitives.neutrals.stone['110'],
        hover: primitives.neutrals.stone['150'],
        pressed: primitives.neutrals.stone['120'],
        dragged: primitives.neutrals.stone['150'],
        selected: primitives.neutrals.stone['160'],
        disabled: primitives.neutrals.stone['90'],
        focused: primitives.neutrals.stone['110'],
        inverse: {
          default: primitives.neutrals.stone['155']
        }
      }
    },
    overlay: {
      main: {
        default: primitives.neutrals.alvieBlack['50%'],
        hover: primitives.neutrals.alvieBlack['75%'],
        pressed: primitives.neutrals.alvieBlack['25%'],
        dragged: primitives.neutrals.alvieBlack['75%'],
        selected: primitives.neutrals.alvieBlack['100'],
        disabled: primitives.neutrals.stone['90'],
        focused: primitives.neutrals.alvieBlack['50%'],
        inverse: {
          default: primitives.neutrals.white['75%']
        }
      }
    },
    brand: {
      main: {
        default: primitives.main.alvieBlue['100'],
        hover: primitives.main.alvieBlue['110'],
        pressed: primitives.main.alvieBlue['90'],
        dragged: primitives.main.alvieBlue['110'],
        selected: primitives.main.alvieBlue['120'],
        disabled: primitives.neutrals.stone['90'],
        focused: primitives.main.alvieBlue['100']
      },
      tonal: {
        superSoft: {
          default: primitives.main.alvieBlue['05'],
          hover: primitives.main.alvieBlue['20'],
          pressed: primitives.main.alvieBlue['60'],
          dragged: primitives.main.alvieBlue['20'],
          selected: primitives.main.alvieBlue['110'],
          disabled: primitives.neutrals.stone['90'],
          focused: primitives.main.alvieBlue['05'],
          inverse: primitives.semantic.info['160']
        },
        soft: {
          default: primitives.main.alvieBlue['60'],
          hover: primitives.main.alvieBlue['90'],
          pressed: primitives.main.alvieBlue['100'],
          dragged: primitives.main.alvieBlue['90'],
          selected: primitives.main.alvieBlue['140'],
          disabled: primitives.neutrals.stone['90'],
          focused: primitives.main.alvieBlue['60'],
          inverse: primitives.main.alvieBlue['140']
        },
        medium: {
          default: primitives.main.alvieBlue['90'],
          hover: primitives.main.alvieBlue['100'],
          pressed: primitives.main.alvieBlue['110'],
          dragged: primitives.main.alvieBlue['100'],
          selected: primitives.main.alvieBlue['160'],
          disabled: primitives.neutrals.stone['90'],
          focused: primitives.main.alvieBlue['90'],
          'inverse 2': primitives.main.alvieBlue['120']
        }
      }
    },
    semantic: {
      info: {
        main: {
          default: primitives.semantic.info['100'],
          hover: primitives.semantic.info['110'],
          pressed: primitives.semantic.info['90'],
          dragged: primitives.semantic.info['110'],
          selected: primitives.semantic.info['120'],
          focused: primitives.semantic.info['100'],
          disabled: primitives.neutrals.stone['90']
        },
        tonal: {
          superSoft: {
            default: primitives.semantic.info['05'],
            hover: primitives.semantic.info['20'],
            pressed: primitives.semantic.info['60'],
            dragged: primitives.semantic.info['20'],
            selected: primitives.semantic.info['110'],
            disabled: primitives.neutrals.stone['90'],
            focused: primitives.semantic.info['05'],
            inverse: primitives.semantic.info['160']
          },
          soft: {
            default: primitives.semantic.info['60'],
            hover: primitives.semantic.info['90'],
            pressed: primitives.semantic.info['100'],
            dragged: primitives.semantic.info['90'],
            selected: primitives.semantic.info['140'],
            disabled: primitives.neutrals.stone['90'],
            focused: primitives.semantic.info['60'],
            inverse: primitives.semantic.info['140']
          },
          medium: {
            default: primitives.semantic.info['90'],
            hover: primitives.semantic.info['100'],
            pressed: primitives.semantic.info['110'],
            dragged: primitives.semantic.info['100'],
            selected: primitives.semantic.info['160'],
            disabled: primitives.neutrals.stone['90'],
            focused: primitives.semantic.info['90'],
            inverse: primitives.semantic.info['120']
          }
        }
      },
      success: {
        main: {
          default: primitives.semantic.success['100'],
          hover: primitives.semantic.success['90'],
          pressed: primitives.semantic.success['110'],
          dragged: primitives.semantic.success['90'],
          selected: primitives.semantic.success['120'],
          disabled: primitives.neutrals.stone['90']
        },
        tonal: {
          superSoft: {
            default: primitives.semantic.success['05'],
            hover: primitives.semantic.success['20'],
            pressed: primitives.semantic.success['40'],
            dragged: primitives.semantic.success['20'],
            selected: primitives.semantic.success['120'],
            focused: primitives.semantic.success['05'],
            disabled: primitives.neutrals.stone['90'],
            inverse: primitives.semantic.success['160']
          },
          soft: {
            default: primitives.semantic.success['40'],
            hover: primitives.semantic.success['90'],
            pressed: primitives.semantic.success['100'],
            dragged: primitives.semantic.success['90'],
            selected: primitives.semantic.success['140'],
            focused: primitives.semantic.success['40'],
            disabled: primitives.neutrals.stone['90'],
            inverse: primitives.semantic.success['140']
          },
          medium: {
            default: primitives.semantic.success['40'],
            hover: primitives.semantic.success['05'],
            pressed: primitives.semantic.success['90'],
            dragged: primitives.semantic.success['05'],
            selected: primitives.semantic.success['160'],
            focused: primitives.semantic.success['40'],
            disabled: primitives.neutrals.stone['90'],
            inverse: primitives.semantic.success['140']
          }
        }
      },
      warning: {
        main: {
          default: primitives.semantic.warning['100'],
          hover: primitives.semantic.warning['90'],
          pressed: primitives.semantic.warning['110'],
          selected: primitives.semantic.warning['120'],
          disabled: primitives.neutrals.stone['90'],
          focused: primitives.semantic.warning['100']
        },
        tonal: {
          superSoft: {
            default: primitives.semantic.warning['05'],
            hover: primitives.semantic.warning['40'],
            pressed: primitives.semantic.warning['60'],
            dragged: primitives.semantic.warning['40'],
            selected: primitives.semantic.warning['120'],
            disabled: primitives.neutrals.stone['90'],
            focused: primitives.semantic.warning['05'],
            inverse: primitives.semantic.warning['160']
          },
          soft: {
            default: primitives.semantic.warning['60'],
            hover: primitives.semantic.warning['90'],
            pressed: primitives.semantic.warning['100'],
            dragged: primitives.semantic.warning['90'],
            selected: primitives.semantic.warning['140'],
            disabled: primitives.neutrals.stone['90'],
            focused: primitives.semantic.warning['60'],
            inverse: primitives.semantic.warning['140']
          },
          medium: {
            default: primitives.semantic.warning['90'],
            hover: primitives.semantic.warning['100'],
            pressed: primitives.semantic.warning['110'],
            dragged: primitives.semantic.warning['100'],
            selected: primitives.semantic.warning['160'],
            disabled: primitives.neutrals.stone['90'],
            focused: primitives.semantic.warning['90'],
            inverse: primitives.semantic.warning['120']
          }
        }
      },
      error: {
        main: {
          default: primitives.semantic.error['100'],
          hover: primitives.semantic.error['90'],
          pressed: primitives.semantic.error['110'],
          selected: primitives.semantic.error['120'],
          dragged: primitives.semantic.error['90'],
          disabled: primitives.neutrals.stone['90']
        },
        tonal: {
          superSoft: {
            default: primitives.semantic.error['05'],
            hover: primitives.semantic.error['20'],
            pressed: primitives.semantic.error['40'],
            dragged: primitives.semantic.error['20'],
            selected: primitives.semantic.error['120'],
            disabled: primitives.neutrals.stone['90'],
            focused: primitives.semantic.error['05'],
            inverse: primitives.semantic.error['160']
          },
          soft: {
            default: primitives.semantic.error['40'],
            hover: primitives.semantic.error['90'],
            pressed: primitives.semantic.error['100'],
            dragged: primitives.semantic.error['90'],
            selected: primitives.semantic.error['110'],
            disabled: primitives.neutrals.stone['90'],
            focused: primitives.semantic.error['40'],
            inverse: primitives.semantic.error['140']
          },
          medium: {
            default: primitives.semantic.error['90'],
            hover: primitives.semantic.error['100'],
            pressed: primitives.semantic.error['110'],
            dragged: primitives.semantic.error['100'],
            selected: primitives.semantic.error['140'],
            disabled: primitives.neutrals.stone['90'],
            focused: primitives.semantic.error['90'],
            inverse: primitives.semantic.error['120']
          }
        }
      },
      neutral: {
        main: {
          default: primitives.neutrals.stone['155'],
          hover: primitives.neutrals.stone['150'],
          pressed: primitives.neutrals.stone['160'],
          selected: primitives.neutrals.alvieBlack['100'],
          dragged: primitives.neutrals.stone['150'],
          disabled: primitives.neutrals.stone['90']
        },
        tonal: {
          superSoft: {
            default: primitives.semantic.info['05'],
            hover: primitives.semantic.info['20'],
            pressed: primitives.semantic.info['60'],
            dragged: primitives.semantic.info['20'],
            selected: primitives.semantic.info['110'],
            disabled: primitives.neutrals.stone['90'],
            focused: primitives.semantic.info['05'],
            inverse: primitives.semantic.info['160']
          },
          soft: {
            default: primitives.neutrals.stone['100'],
            inverse: primitives.neutrals.stone['160'],
            hover: primitives.neutrals.stone['90'],
            pressed: primitives.neutrals.stone['110'],
            dragged: primitives.neutrals.stone['90'],
            selected: primitives.neutrals.stone['160'],
            disabled: primitives.neutrals.stone['90']
          },
          medium: {
            default: primitives.neutrals.stone['110'],
            inverse: primitives.neutrals.stone['155'],
            hover: primitives.neutrals.stone['120'],
            pressed: primitives.neutrals.stone['150'],
            dragged: primitives.neutrals.stone['120'],
            selected: primitives.neutrals.alvieBlack['100'],
            disabled: primitives.neutrals.stone['90']
          }
        }
      }
    }
  },
  foreground: {
    main: {
      primary: primitives.neutrals.alvieBlack['100'],
      secondary: primitives.neutrals.stone['155'],
      disabled: primitives.neutrals.stone['120'],
      inverse: primitives.neutrals.white['100'],
      link: primitives.main.alvieBlue['110'],
      linkInverse: primitives.main.alvieBlue['60'],
      interactive: primitives.main.alvieBlue['110'],
      staticWhite: primitives.neutrals.white['100'],
      staticBlack: primitives.neutrals.alvieBlack['100']
    },
    semantic: {
      neutral: {
        default: primitives.neutrals.stone['160'],
        inverse: primitives.neutrals.white['100']
      },
      info: {
        default: primitives.semantic.info['120'],
        tonal: {
          default: primitives.semantic.info['120'],
          inverse: primitives.semantic.info['60']
        },
        inverse: primitives.semantic.info['05']
      },
      success: {
        default: primitives.semantic.success['140'],
        tonal: {
          default: primitives.semantic.success['140'],
          inverse: primitives.semantic.success['40']
        },
        inverse: primitives.semantic.success['05']
      },
      warning: {
        default: primitives.semantic.warning['140'],
        tonal: {
          default: primitives.semantic.warning['140'],
          inverse: primitives.semantic.warning['60']
        },
        inverse: primitives.semantic.warning['05']
      },
      error: {
        default: primitives.semantic.error['120'],
        tonal: {
          default: primitives.semantic.error['120'],
          inverse: primitives.semantic.error['40']
        },
        inverse: primitives.semantic.error['05']
      }
    },
    brand: {
      default: primitives.main.alvieBlue['110'],
      inverse: primitives.main.alvieBlue['60']
    }
  },
  fill: {
    tonalMedium: primitives.neutrals.stone['100']
  },
  border: {
    main: {
      default: primitives.neutrals.stone['110'],
      tonal: primitives.neutrals.stone['100']
    },
    focus: {
      brand: {
        primary: primitives.main.alvieBlue['100'],
        haloSubtle: primitives.main.alvieBlue['05'],
        secondary: primitives.neutrals.white['100'],
        halo: primitives.main.alvieBlue['60']
      }
    },
    error: {
      primary: primitives.semantic.error['100'],
      secondary: primitives.neutrals.white['100'],
      halo: primitives.semantic.error['05']
    },
    success: {
      primary: primitives.semantic.success['100'],
      secondary: primitives.neutrals.white['100'],
      halo: primitives.semantic.success['05']
    }
  },
  dataViz: {
    primary: {
      1: {
        fill: {
          default: primitives.main.alvieBlue['100'],
          hover: primitives.main.alvieBlue['110'],
          pressed: primitives.main.alvieBlue['90'],
          dragged: primitives.main.alvieBlue['110'],
          selected: primitives.main.alvieBlue['120'],
          focused: primitives.main.alvieBlue['100'],
          subtle: primitives.main.alvieBlue['60'],
          disabled: primitives.neutrals.stone['90'],
          muted: primitives.main.alvieBlue['30%'],
          tonal: {
            superSoft: {
              default: primitives.main.alvieBlue['05'],
              hover: primitives.main.alvieBlue['20'],
              pressed: primitives.main.alvieBlue['60'],
              dragged: primitives.main.alvieBlue['20'],
              selected: primitives.main.alvieBlue['110'],
              focused: primitives.main.alvieBlue['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.main.alvieBlue['30%']
            },
            soft: {
              default: primitives.main.alvieBlue['60'],
              hover: primitives.main.alvieBlue['90'],
              pressed: primitives.main.alvieBlue['100'],
              dragged: primitives.main.alvieBlue['90'],
              selected: primitives.main.alvieBlue['140'],
              focused: primitives.main.alvieBlue['60'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.main.alvieBlue['30%']
            }
          }
        },
        border: {
          default: primitives.main.alvieBlue['110'],
          subtle: primitives.main.alvieBlue['90'],
          halo: primitives.main.alvieBlue['05']
        }
      },
      2: {
        fill: {
          default: primitives.dataViz.teal['100'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.teal['05'],
              hover: primitives.dataViz.teal['20'],
              pressed: primitives.dataViz.teal['50'],
              dragged: primitives.dataViz.teal['20'],
              selected: primitives.dataViz.teal['110'],
              focused: primitives.dataViz.teal['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.teal['30%']
            },
            soft: {
              default: primitives.dataViz.teal['50'],
              hover: primitives.dataViz.teal['90'],
              pressed: primitives.dataViz.teal['100'],
              dragged: primitives.dataViz.teal['90'],
              selected: primitives.dataViz.teal['140'],
              focused: primitives.dataViz.teal['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.teal['30%']
            }
          },
          hover: primitives.dataViz.teal['110'],
          pressed: primitives.dataViz.teal['90'],
          dragged: primitives.dataViz.teal['110'],
          selected: primitives.dataViz.teal['120'],
          focused: primitives.dataViz.teal['100'],
          disabled: primitives.neutrals.stone['90'],
          muted: primitives.dataViz.teal['30%'],
          subtle: primitives.dataViz.teal['50']
        },
        border: {
          default: primitives.dataViz.teal['110'],
          subtle: primitives.dataViz.teal['90']
        }
      },
      3: {
        fill: {
          default: primitives.dataViz.orange['100'],
          subtle: primitives.dataViz.orange['50'],
          hover: primitives.dataViz.orange['110'],
          pressed: primitives.dataViz.orange['90'],
          dragged: primitives.dataViz.orange['110'],
          selected: primitives.dataViz.orange['120'],
          focused: primitives.dataViz.orange['100'],
          disabled: primitives.neutrals.stone['90'],
          muted: primitives.dataViz.orange['30%'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.orange['05'],
              hover: primitives.dataViz.orange['20'],
              pressed: primitives.dataViz.orange['50'],
              dragged: primitives.dataViz.orange['20'],
              selected: primitives.dataViz.orange['110'],
              focused: primitives.dataViz.orange['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.orange['30%']
            },
            soft: {
              default: primitives.dataViz.orange['50'],
              hover: primitives.dataViz.orange['90'],
              pressed: primitives.dataViz.orange['100'],
              dragged: primitives.dataViz.orange['90'],
              selected: primitives.dataViz.orange['140'],
              focused: primitives.dataViz.orange['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.orange['30%']
            }
          }
        },
        border: {
          default: primitives.dataViz.orange['110'],
          subtle: primitives.dataViz.orange['90']
        }
      },
      4: {
        fill: {
          default: primitives.dataViz.magneta['100'],
          hover: primitives.dataViz.magneta['110'],
          pressed: primitives.dataViz.magneta['90'],
          dragged: primitives.dataViz.magneta['110'],
          selected: primitives.dataViz.magneta['120'],
          focused: primitives.dataViz.magneta['100'],
          disabled: primitives.neutrals.stone['90'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.magneta['05'],
              hover: primitives.dataViz.magneta['20'],
              pressed: primitives.dataViz.magneta['50'],
              dragged: primitives.dataViz.magneta['20'],
              selected: primitives.dataViz.magneta['110'],
              focused: primitives.dataViz.magneta['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.magneta['30%']
            },
            soft: {
              default: primitives.dataViz.magneta['50'],
              hover: primitives.dataViz.magneta['90'],
              pressed: primitives.dataViz.magneta['100'],
              dragged: primitives.dataViz.magneta['90'],
              selected: primitives.dataViz.magneta['140'],
              focused: primitives.dataViz.magneta['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.magneta['30%']
            }
          },
          subtle: primitives.dataViz.magneta['50'],
          muted: primitives.dataViz.magneta['30%']
        },
        border: {
          default: primitives.dataViz.magneta['110'],
          subtle: primitives.dataViz.magneta['90']
        }
      },
      5: {
        fill: {
          default: primitives.dataViz.violet['100'],
          hover: primitives.dataViz.violet['110'],
          pressed: primitives.dataViz.violet['90'],
          dragged: primitives.dataViz.violet['110'],
          selected: primitives.dataViz.violet['120'],
          focused: primitives.dataViz.violet['100'],
          disabled: primitives.neutrals.stone['90'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.violet['05'],
              hover: primitives.dataViz.violet['20'],
              pressed: primitives.dataViz.violet['50'],
              dragged: primitives.dataViz.violet['20'],
              selected: primitives.dataViz.violet['110'],
              focused: primitives.dataViz.violet['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.violet['30%']
            },
            soft: {
              default: primitives.dataViz.violet['50'],
              hover: primitives.dataViz.violet['90'],
              pressed: primitives.dataViz.violet['100'],
              dragged: primitives.dataViz.violet['90'],
              selected: primitives.dataViz.violet['140'],
              focused: primitives.dataViz.violet['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.violet['30%']
            }
          },
          muted: primitives.dataViz.violet['30%'],
          subtle: primitives.dataViz.violet['50']
        },
        border: {
          default: primitives.dataViz.violet['110'],
          subtle: primitives.dataViz.violet['90']
        }
      },
      6: {
        fill: {
          default: primitives.dataViz.andesite['100'],
          hover: primitives.dataViz.andesite['110'],
          pressed: primitives.dataViz.andesite['90'],
          dragged: primitives.dataViz.andesite['110'],
          selected: primitives.dataViz.andesite['120'],
          focused: primitives.dataViz.andesite['100'],
          disabled: primitives.neutrals.stone['90'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.andesite['05'],
              hover: primitives.dataViz.andesite['20'],
              pressed: primitives.dataViz.andesite['50'],
              dragged: primitives.dataViz.andesite['20'],
              selected: primitives.dataViz.andesite['110'],
              focused: primitives.dataViz.andesite['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.andesite['30%']
            },
            soft: {
              default: primitives.dataViz.andesite['50'],
              hover: primitives.dataViz.andesite['90'],
              pressed: primitives.dataViz.andesite['100'],
              dragged: primitives.dataViz.andesite['90'],
              selected: primitives.dataViz.andesite['140'],
              focused: primitives.dataViz.andesite['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.andesite['30%']
            }
          },
          muted: primitives.dataViz.andesite['30%'],
          subtle: primitives.dataViz.andesite['50']
        },
        border: {
          default: primitives.dataViz.andesite['110'],
          subtle: primitives.dataViz.andesite['90']
        }
      },
      7: {
        fill: {
          default: primitives.dataViz.cobalt['100'],
          hover: primitives.dataViz.cobalt['110'],
          pressed: primitives.dataViz.cobalt['90'],
          dragged: primitives.dataViz.cobalt['110'],
          selected: primitives.dataViz.cobalt['120'],
          focused: primitives.dataViz.cobalt['100'],
          disabled: primitives.neutrals.stone['90'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.cobalt['05'],
              hover: primitives.dataViz.cobalt['20'],
              pressed: primitives.dataViz.cobalt['50'],
              dragged: primitives.dataViz.cobalt['20'],
              selected: primitives.dataViz.cobalt['110'],
              focused: primitives.dataViz.cobalt['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.cobalt['30%']
            },
            soft: {
              default: primitives.dataViz.cobalt['50'],
              hover: primitives.dataViz.cobalt['90'],
              pressed: primitives.dataViz.cobalt['100'],
              dragged: primitives.dataViz.cobalt['90'],
              selected: primitives.dataViz.cobalt['140'],
              focused: primitives.dataViz.cobalt['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.cobalt['30%']
            }
          },
          muted: primitives.dataViz.cobalt['30%'],
          subtle: primitives.dataViz.cobalt['50']
        },
        border: {
          default: primitives.dataViz.cobalt['110'],
          subtle: primitives.dataViz.cobalt['90']
        }
      },
      8: {
        fill: {
          default: primitives.dataViz.brown['100'],
          hover: primitives.dataViz.brown['110'],
          pressed: primitives.dataViz.brown['90'],
          dragged: primitives.dataViz.brown['110'],
          selected: primitives.dataViz.brown['120'],
          focused: primitives.dataViz.brown['100'],
          disabled: primitives.neutrals.stone['90'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.brown['05'],
              hover: primitives.dataViz.brown['20'],
              pressed: primitives.dataViz.brown['50'],
              dragged: primitives.dataViz.brown['20'],
              selected: primitives.dataViz.brown['110'],
              focused: primitives.dataViz.brown['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.brown['30%']
            },
            soft: {
              default: primitives.dataViz.brown['50'],
              hover: primitives.dataViz.brown['90'],
              pressed: primitives.dataViz.brown['100'],
              dragged: primitives.dataViz.brown['90'],
              selected: primitives.dataViz.brown['140'],
              focused: primitives.dataViz.brown['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.brown['30%']
            }
          },
          muted: primitives.dataViz.brown['30%'],
          subtle: primitives.dataViz.brown['50']
        },
        border: {
          default: primitives.dataViz.brown['110'],
          subtle: primitives.dataViz.brown['90']
        }
      }
    },
    'primary-2': primitives.dataViz.teal['100'],
    'primary-8': primitives.dataViz.brown['100'],
    'secondary-8': primitives.dataViz.brass['100'],
    secondary: {
      1: {
        fill: {
          default: primitives.dataViz.pink['100'],
          hover: primitives.dataViz.pink['110'],
          pressed: primitives.dataViz.pink['90'],
          dragged: primitives.dataViz.pink['110'],
          selected: primitives.dataViz.pink['120'],
          focused: primitives.dataViz.pink['100'],
          disabled: primitives.neutrals.stone['90'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.pink['05'],
              hover: primitives.dataViz.pink['20'],
              pressed: primitives.dataViz.pink['50'],
              dragged: primitives.dataViz.pink['20'],
              selected: primitives.dataViz.pink['110'],
              focused: primitives.dataViz.pink['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.pink['30%']
            },
            soft: {
              default: primitives.dataViz.pink['50'],
              hover: primitives.dataViz.pink['90'],
              pressed: primitives.dataViz.pink['100'],
              dragged: primitives.dataViz.pink['90'],
              selected: primitives.dataViz.pink['140'],
              focused: primitives.dataViz.pink['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.pink['30%']
            }
          },
          muted: primitives.dataViz.pink['30%'],
          subtle: primitives.dataViz.pink['50']
        },
        border: {
          default: primitives.dataViz.pink['110'],
          subtle: primitives.dataViz.pink['90'],
          halo: primitives.dataViz.pink['05']
        }
      },
      2: {
        fill: {
          default: primitives.dataViz.olive['100'],
          hover: primitives.dataViz.olive['110'],
          pressed: primitives.dataViz.olive['90'],
          dragged: primitives.dataViz.olive['110'],
          selected: primitives.dataViz.olive['120'],
          focused: primitives.dataViz.olive['100'],
          disabled: primitives.neutrals.stone['90'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.olive['05'],
              hover: primitives.dataViz.olive['20'],
              pressed: primitives.dataViz.olive['50'],
              dragged: primitives.dataViz.olive['20'],
              selected: primitives.dataViz.olive['110'],
              focused: primitives.dataViz.olive['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.olive['30%']
            },
            soft: {
              default: primitives.dataViz.olive['50'],
              hover: primitives.dataViz.olive['90'],
              pressed: primitives.dataViz.olive['100'],
              dragged: primitives.dataViz.olive['90'],
              selected: primitives.dataViz.olive['140'],
              focused: primitives.dataViz.olive['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.olive['30%']
            }
          },
          muted: primitives.dataViz.olive['30%'],
          subtle: primitives.dataViz.olive['50']
        },
        border: {
          default: primitives.dataViz.olive['110'],
          subtle: primitives.dataViz.olive['90']
        }
      },
      3: {
        fill: {
          default: primitives.dataViz.sienna['100'],
          hover: primitives.dataViz.sienna['110'],
          pressed: primitives.dataViz.sienna['90'],
          dragged: primitives.dataViz.sienna['110'],
          selected: primitives.dataViz.sienna['120'],
          focused: primitives.dataViz.sienna['100'],
          disabled: primitives.neutrals.stone['90'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.sienna['05'],
              hover: primitives.dataViz.sienna['20'],
              pressed: primitives.dataViz.sienna['50'],
              dragged: primitives.dataViz.sienna['20'],
              selected: primitives.dataViz.sienna['110'],
              focused: primitives.dataViz.sienna['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.sienna['30%']
            },
            soft: {
              default: primitives.dataViz.sienna['50'],
              hover: primitives.dataViz.sienna['90'],
              pressed: primitives.dataViz.sienna['100'],
              dragged: primitives.dataViz.sienna['90'],
              selected: primitives.dataViz.sienna['140'],
              focused: primitives.dataViz.sienna['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.sienna['30%']
            }
          },
          muted: primitives.dataViz.sienna['30%']
        },
        border: {
          default: primitives.dataViz.sienna['110'],
          subtle: primitives.dataViz.sienna['90']
        }
      },
      4: {
        fill: {
          default: primitives.dataViz.green['100'],
          hover: primitives.dataViz.green['110'],
          pressed: primitives.dataViz.green['90'],
          dragged: primitives.dataViz.green['110'],
          selected: primitives.dataViz.green['120'],
          focused: primitives.dataViz.green['100'],
          disabled: primitives.neutrals.stone['90'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.green['05'],
              hover: primitives.dataViz.green['20'],
              pressed: primitives.dataViz.green['50'],
              dragged: primitives.dataViz.green['20'],
              selected: primitives.dataViz.green['110'],
              focused: primitives.dataViz.green['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.green['30%']
            },
            soft: {
              default: primitives.dataViz.green['50'],
              hover: primitives.dataViz.green['90'],
              pressed: primitives.dataViz.green['100'],
              dragged: primitives.dataViz.green['90'],
              selected: primitives.dataViz.green['140'],
              focused: primitives.dataViz.green['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.green['30%']
            }
          },
          muted: primitives.dataViz.green['30%']
        },
        border: {
          default: primitives.dataViz.green['110'],
          subtle: primitives.dataViz.green['90']
        }
      },
      5: {
        fill: {
          default: primitives.dataViz.caramel['100'],
          hover: primitives.dataViz.caramel['110'],
          pressed: primitives.dataViz.caramel['90'],
          dragged: primitives.dataViz.caramel['110'],
          selected: primitives.dataViz.caramel['120'],
          focused: primitives.dataViz.caramel['100'],
          disabled: primitives.neutrals.stone['90'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.caramel['05'],
              hover: primitives.dataViz.caramel['20'],
              pressed: primitives.dataViz.caramel['50'],
              dragged: primitives.dataViz.caramel['20'],
              selected: primitives.dataViz.caramel['110'],
              focused: primitives.dataViz.caramel['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.caramel['30%']
            },
            soft: {
              default: primitives.dataViz.caramel['50'],
              hover: primitives.dataViz.caramel['90'],
              pressed: primitives.dataViz.caramel['100'],
              dragged: primitives.dataViz.caramel['90'],
              selected: primitives.dataViz.caramel['140'],
              focused: primitives.dataViz.caramel['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.caramel['30%']
            }
          },
          muted: primitives.dataViz.caramel['30%']
        },
        border: {
          default: primitives.dataViz.caramel['110'],
          subtle: primitives.dataViz.caramel['90']
        }
      },
      6: {
        fill: {
          default: primitives.dataViz.aqua['100'],
          hover: primitives.dataViz.aqua['110'],
          pressed: primitives.dataViz.aqua['90'],
          dragged: primitives.dataViz.aqua['110'],
          selected: primitives.dataViz.aqua['120'],
          focused: primitives.dataViz.aqua['100'],
          disabled: primitives.neutrals.stone['90'],
          muted: primitives.dataViz.aqua['30%'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.aqua['05'],
              hover: primitives.dataViz.aqua['20'],
              pressed: primitives.dataViz.aqua['50'],
              dragged: primitives.dataViz.aqua['20'],
              selected: primitives.dataViz.aqua['110'],
              focused: primitives.dataViz.aqua['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.aqua['30%']
            },
            soft: {
              default: primitives.dataViz.aqua['50'],
              hover: primitives.dataViz.aqua['90'],
              pressed: primitives.dataViz.aqua['100'],
              dragged: primitives.dataViz.aqua['90'],
              selected: primitives.dataViz.aqua['140'],
              focused: primitives.dataViz.aqua['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.aqua['30%']
            }
          }
        },
        border: {
          default: primitives.dataViz.aqua['110'],
          subtle: primitives.dataViz.aqua['90']
        }
      },
      7: {
        fill: {
          default: primitives.dataViz.salmon['100'],
          hover: primitives.dataViz.salmon['110'],
          pressed: primitives.dataViz.salmon['90'],
          dragged: primitives.dataViz.salmon['110'],
          selected: primitives.dataViz.salmon['120'],
          focused: primitives.dataViz.salmon['100'],
          disabled: primitives.neutrals.stone['90'],
          muted: primitives.dataViz.salmon['30%'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.salmon['05'],
              hover: primitives.dataViz.salmon['20'],
              pressed: primitives.dataViz.salmon['50'],
              dragged: primitives.dataViz.salmon['20'],
              selected: primitives.dataViz.salmon['110'],
              focused: primitives.dataViz.salmon['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.salmon['30%']
            },
            soft: {
              default: primitives.dataViz.salmon['50'],
              hover: primitives.dataViz.salmon['90'],
              pressed: primitives.dataViz.salmon['100'],
              dragged: primitives.dataViz.salmon['90'],
              selected: primitives.dataViz.salmon['140'],
              focused: primitives.dataViz.salmon['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.salmon['30%']
            }
          }
        },
        border: {
          default: primitives.dataViz.salmon['110'],
          subtle: primitives.dataViz.salmon['90']
        }
      },
      8: {
        fill: {
          default: primitives.dataViz.brass['100'],
          hover: primitives.dataViz.brass['110'],
          pressed: primitives.dataViz.brass['90'],
          dragged: primitives.dataViz.brass['110'],
          selected: primitives.dataViz.brass['120'],
          focused: primitives.dataViz.brass['100'],
          disabled: primitives.neutrals.stone['90'],
          tonal: {
            superSoft: {
              default: primitives.dataViz.brass['05'],
              hover: primitives.dataViz.brass['20'],
              pressed: primitives.dataViz.brass['50'],
              dragged: primitives.dataViz.brass['20'],
              selected: primitives.dataViz.brass['110'],
              focused: primitives.dataViz.brass['05'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.brass['30%']
            },
            soft: {
              default: primitives.dataViz.brass['50'],
              hover: primitives.dataViz.brass['90'],
              pressed: primitives.dataViz.brass['100'],
              dragged: primitives.dataViz.brass['90'],
              selected: primitives.dataViz.brass['140'],
              focused: primitives.dataViz.brass['50'],
              disabled: primitives.neutrals.stone['90'],
              muted: primitives.dataViz.brass['30%']
            }
          },
          muted: primitives.dataViz.brass['30%']
        },
        border: {
          default: primitives.dataViz.brass['110'],
          subtle: primitives.dataViz.brass['90']
        }
      }
    },
    semantic: {
      info: {
        fill: {
          default: primitives.semantic.info['100'],
          disabled: primitives.semantic.info['30%']
        },
        border: {
          default: primitives.semantic.info['100'],
          halo: primitives.semantic.info['05']
        }
      },
      success: {
        fill: {
          default: primitives.semantic.success['100'],
          disabled: primitives.semantic.success['30%']
        },
        border: {
          default: primitives.semantic.success['110']
        }
      },
      warning: {
        fill: {
          default: primitives.semantic.warning['100'],
          disabled: primitives.semantic.warning['30%']
        },
        border: {
          default: primitives.semantic.warning['110']
        }
      },
      error: {
        fill: {
          default: primitives.semantic.error['100'],
          disabled: primitives.semantic.error['30%']
        },
        border: {
          default: primitives.semantic.error['110']
        }
      }
    }
  }
} as const satisfies SemanticTokens
